var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"message-tip",attrs:{"href":_vm.$ComDomain.Modules.message}},[_c('Badge',{attrs:{"count":_vm.messageCount}},[_c('Icon',{attrs:{"type":"ios-mail-outline","size":"22"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54538242","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commons/components/layout/MessageTip.vue
// module id = null
// module chunks = 